<script setup lang="ts">
import { onMounted, ref, useTemplateRef, type HTMLAttributes } from 'vue';
import { FieldError } from '@/components/ui/field/index.ts';
import { cn } from '@/lib/utils';

const props = defineProps<{
    class?: HTMLAttributes['class'];
}>();

const fieldset = useTemplateRef('field-set');
const errors = ref([]);

onMounted(() => {
    fieldset.value?.addEventListener('formie:add-error', (e) => {
        const { message } = e.detail;
        errors.value.push(message);
    });

    fieldset.value?.addEventListener('formie:remove-error', () => {
        errors.value = [];
    });
});
</script>

<template>
    <fieldset
        ref="field-set"
        data-slot="field-set"
        :class="
            cn(
                'flex flex-col gap-6',
                'has-[>[data-slot=checkbox-group]]:gap-3 has-[>[data-slot=radio-group]]:gap-3',
                props.class
            )
        "
    >
        <slot />
        <FieldError
            v-if="errors.length > 0"
            :errors="errors"
            class="basis-full"
        />
    </fieldset>
</template>
